import { withTranslation } from '@application/i18n/with_translation';
import { Button, Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Auth } from '@feature/auth/auth.component';
import { EmptyState } from './_empty_state.component';

export function SignInEmptyState() {
	return (
		<EmptyState>
			<Flex align='center' gap={tokens.size.x2}>
				<Flex gap={tokens.size.x1}>
					<Text.h2 variant='headingSmall'>{withTranslation('PW.Component.Visits.NoAuth.Title')}</Text.h2>
					<Text.p variant='bodyRegular'>{withTranslation('PW.Component.Visits.NoAuth.Description')}</Text.p>
				</Flex>
				<Auth.SignInButton />
			</Flex>
		</EmptyState>
	);
}
